import React from 'react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { Stack, Text } from '@fluentui/react';
import OutlookLocationContentsViewerState, { IContextCommands, IOutlookAppCommands } from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import API, { IEntityContentItem, IUserConfigPackage } from '../API';
import LegalEntityRootFolder from './LegalEntityRootFolder';

export class OutlookTabRecentState {

	userConfig: IUserConfigPackage;
	commands: IOutlookAppCommands;

	public recentDocs: OutlookLocationContentsViewerState;
	initialLoaded: boolean = false;

	constructor(userConfig: IUserConfigPackage, commands: IOutlookAppCommands, ctxCommands: IContextCommands) {
		this.userConfig = userConfig;
		this.commands = commands;

		this.recentDocs = new OutlookLocationContentsViewerState(
			'Recent documents',
			'',
			'',
			'',
			'',
			this.userConfig,
			commands,
			ctxCommands
		);

		makeAutoObservable(this);

	}

	ensureInitialLoaded() {
		if (!this.initialLoaded) {
			this.initialLoaded = true;
			this.updateRecent();
		}
	}


	public async updateRecent() {
		this.recentDocs.setLoading(true);
		var api = new API(await this.userConfig.getToken());
		this.setRecent(await api.recent());
	}

	public setRecent(recent: IEntityContentItem[]) {
		this.recentDocs.setResult({
			folders: [],
			documents: recent,
			webUrl: '',
		});
	}

}

export interface IOutlookTabRecentProps {
	state: OutlookTabRecentState;
}

class OutlookTabRecent extends React.Component<IOutlookTabRecentProps, {}> {
	componentDidMount(): void {
		this.props.state.ensureInitialLoaded();
	}

	render(): React.ReactNode {
		if (this.props.state.recentDocs.documentStates.length > 0) {
			return (
				<Stack>
					<LegalEntityRootFolder state={this.props.state.recentDocs} />
				</Stack>
			);
		} else {
			return <Text>No recent documents.</Text>;
		}
	}
}

export default observer(OutlookTabRecent);
